module.exports = __webpack_public_path__ + "4faaed421c14d3ac80b0659e049245cc.MP3";